import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { DomSanitizer  } from '@angular/platform-browser';

@Component({
  selector: 'app-img-gallery',
  templateUrl: './img-gallery.component.html',
  styleUrls: ['./img-gallery.component.css']
})
export class ImgGalleryComponent implements OnInit {

  images: any[]=[];
  slideIndex = 1;
  Height: any;
  isSuccess: boolean = false;
  selectedHero:number=1;
  eventtype:any[]=[];

  constructor(private service: DataService,
    public sanitizer: DomSanitizer) { }

  ngOnInit() {
     //this.getImages();
    // this.calheight();
    this.GetEventType()
  }

  calheight() {
    this.Height = window.innerHeight - 200;
  }
  GetEventType(){
    let inputJson = {
      DbCon: this.service.db,
    }
    this.service.GetEventType(inputJson).subscribe(
      (data : any[]) => {
        
        if(data['Status'] == 'Success') {
          // this.isSuccess = true;
          this.eventtype = data['EventTypes'];
          
          console.log(JSON.stringify( this.eventtype))
          this.getImages( this.eventtype[0].EventTypeId);
        } else {
          console.log((data['Message']));
          return false;
        }
      }, (error) => {
        console.log(error);
      }
    )
  }

  onSelect(hero): void {
    this.selectedHero = hero;
this.getImages(hero)
// alert(hero)
  }
  getImages(id) { 
    let inputJson = {
      DbCon: this.service.db,
      Entity: "",
      EntityId: -1,
      EventTypeId:id,
      IsVideo: false,
     
      Schoolcode:this.service.scode
    }
    this.service.GetAllEvents6(inputJson).subscribe(
      (data : any[]) => {
        
        if(data['Status'] == 'Success') {
          this.isSuccess = true;
          this.images = data['Events'];
          console.log(JSON.stringify(data))
        } else {
          console.log((data['Message']));
          return false;
        }
      }, (error) => {
        console.log(error);
      }
    )
  }



  // getImages() { 
  //   let inputJson = {
  //     DbCon: this.service.db,
  //     Entity: "",
  //     EntityId: -1,
  //     IsVideo: false,
  //     Schoolcode: this.service.scode
  //   }   
  //   this.service.GetAllEvents5(inputJson).subscribe(
  //     (data : any[]) => {
  //       if(data['Status'] == 'Success') {
  //         this.isSuccess = true;
  //         this.images = data['Events'];
  //         localStorage.setItem('imageData', JSON.stringify(this.images))
  //       } else {
  //         console.log((data['Message']));
  //         return false;
  //       }
  //     }, (error) => {
  //       console.log(error);
  //     }
  //   )
  // }
}

